// Re-export from presentation layer for backward compatibility
export {
  ProductVariantsStore,
  ProductImagesStore,
  ProductListItemViewModel,
  ProductSimpleListItemViewModel,
  ProductWithVariantsListItemViewModel,
  ProductSimpleViewModel,
  ProductWithVariantsViewModel,
} from '@/src/presentation/view-models/product'

export type {
  IProductListItemViewModel,
  WarehouseAvailable,
  ProductViewModel,
} from '@/src/presentation/view-models/product'
